module.exports = __webpack_public_path__ + "static/media/Talent-solution---illustration.ef8365e5.svg";